var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24358 1.23023C1.74802 2.30031 0 4.77928 0 7.66666C0 11.5328 3.1339 14.6667 7 14.6667C10.8661 14.6667 14 11.5328 14 7.66666C14.0008 6.66385 13.7858 5.6726 13.3694 4.76029C12.9531 3.84799 12.3452 3.03602 11.5871 2.37956L13.3 0.666664H9.1V4.86666L10.5945 3.37216C11.6044 4.21732 12.2841 5.39134 12.5142 6.68794C12.7444 7.98454 12.5103 9.32077 11.8529 10.4619C11.1956 11.603 10.1572 12.4759 8.92016 12.9273C7.68308 13.3788 6.32649 13.3798 5.08874 12.9303C3.85098 12.4807 2.81123 11.6093 2.15219 10.4693C1.49315 9.32916 1.25697 7.99329 1.48514 6.69634C1.71332 5.39939 2.39126 4.22434 3.39984 3.37764C3.82562 3.02021 4.29882 2.73094 4.8026 2.51598L4.24358 1.23023Z",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c617bf028666cd7043b4172ccff485ee.svg";
export { ForwardRef as ReactComponent };